import {
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoSectionContainer, showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {useAuthState} from "../../../context/AuthContext";
import {useParams} from "react-router-dom";
import {ReportBox, ReportsItemTypes} from "../../../raikoComponents/reportBox/ReportBox";
import icExcel from "../../../assets/svg/microsoft-excel.svg";
import icPdf from "../../../assets/svg/pdf.svg";
import {AccountService} from "../../../serverService/account/AccountService";
import {doDownloadFile} from "../../../util/DownloadHelper";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";

export default function AccountDetailReports() {

    const {fundID} = useAuthState()
    const {id: accountId} = useParams()

    const service = new AccountService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    function getReport(type) {
        loading.show()
        service.getDepositAccountReports(fundID, accountId, type)
            .then(response => {
                doDownloadFile(response, `گزارش وضعیت حساب ${accountId}`, type)
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function getAccountLoanReport(type) {
        loading.show()
        service.getAccountLoansReports(fundID, accountId, type)
            .then(response=>{
                doDownloadFile(response, `گزارش وام های حساب ${accountId}`, type)
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_=>{
            loading.hide()
        })
    }

    return (
        <RaikoGridOneColumn>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"گزارش خلاصه وضعیت حساب"}
                >
                    <RaikoGridTwoColumn>
                        <ReportBox
                            label={"EXCEL"}
                            icon={icExcel}
                            action={_ => {
                                getReport(ReportsItemTypes.XLSX.id);
                            }}
                        />

                        <ReportBox
                            label={"PDF"}
                            icon={icPdf}
                            action={_ => {
                                getReport(ReportsItemTypes.PDF.id);
                            }}
                        />
                    </RaikoGridTwoColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>

            <RaikoBaseCardContainer>
                <RaikoSectionContainer title={"گزارش وام های حساب"}>
                    <RaikoGridTwoColumn>
                        <ReportBox
                            label={"EXCEL"}
                            icon={icExcel}
                            action={_ => {
                                getAccountLoanReport(ReportsItemTypes.XLSX.id);
                            }}
                        />

                        <ReportBox
                            label={"PDF"}
                            icon={icPdf}
                            action={_ => {
                                getAccountLoanReport(ReportsItemTypes.PDF.id);
                            }}
                        />
                    </RaikoGridTwoColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
        </RaikoGridOneColumn>
    )
}
